import BaseEntity from './BaseEntity';
export default class SimplePullRequestMetric extends BaseEntity {
    constructor(metric) {
        super();
        this.merged = [];
        this.mergedAvgTime = 0;
        this.review = [];
        this.reviewAvgTime = 0;
        this.workInProgress = [];
        this.workInProgressAvgTime = 0;
        this.merged = this.parseProperty(metric, 'merged');
        this.mergedAvgTime = this.parseProperty(metric, 'mergedAvgTime');
        this.review = this.parseProperty(metric, 'review');
        this.reviewAvgTime = this.parseProperty(metric, 'reviewAvgTime');
        this.startDate = this.parseProperty(metric, 'startDate');
        this.workInProgress = this.parseProperty(metric, 'workInProgress');
        this.workInProgressAvgTime = this.parseProperty(metric, 'workInProgressAvgTime');
    }
    getCycleTime() {
        return this.workInProgressAvgTime + this.reviewAvgTime + this.mergedAvgTime;
    }
    getWipPercentage(cycleTime) {
        return Math.round((this.workInProgressAvgTime / cycleTime) * 100);
    }
    getReviewPercentage(cycleTime) {
        return Math.round((this.reviewAvgTime / cycleTime) * 100);
    }
    getMergePercentage(cycleTime) {
        return Math.round((this.mergedAvgTime / cycleTime) * 100);
    }
}
